import React from 'react';
import './Blog.css'
import fahim from '../../images/blog-image/fahim.jpg'
import { BsFacebook, BsLinkedin, BsInstagram, BsGithub, BsFileEarmarkPdf } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import npm from '../../images/blog-image/npm.png'
import npm1 from '../../images/blog-image/npm1.jpeg'
import studyAbroad from '../../images/blog-image/study-abroad.jpg'
import visa from '../../images/blog-image/visa.jpg'
import program from '../../images/blog-image/study-program.jpg'
import useTitle from '../../Hooks/useTitle';
import { FaXTwitter } from 'react-icons/fa6';
import resume from '../../images/blog-image/resume.png'
import code from '../../images/blog-image/code.jpeg'


import ReactPrint from 'react-to-print';
import { useRef } from 'react';




import {
    TwitterShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    WhatsappShareButton,
    TwitterIcon,
    FacebookIcon,
    LinkedinIcon,
    WhatsappIcon,
} from "react-share";




import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import { useLanguage } from '../../context/LanguageContext';
SwiperCore.use([Autoplay, Pagination]);









const Blog4Details = () => {


    const shareUrl = window.location.href
    // console.log('Current Window Location: ', window.location)
    // console.log('Current Page URL: ', window.location.href)
    // console.log('Path Name: ', window.location.pathname)

    const { language } = useLanguage()

    const ref = useRef();

    window.scrollTo(0, 0);
    useTitle('Blog-Everything You Need to Know about Student Visa');


    const postUrl = `https://fahim-faysal-portfolio.netlify.app/blog2`;
    const postTitle = 'Everything You Need to Know about Student Visa';
    const shareOnTwitter = () => {
        window.open(`https://twitter.com/intent/tweet?text=${postTitle}&url=${postUrl}`, '_blank');
    };
    const shareOnFacebook = () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${postUrl}`, '_blank');
    };
    const shareOnLinkedIn = () => {
        window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${postUrl}&title=${postTitle}`, '_blank');
    };




    return (
        <div className=' mt-12 lg:px-2 md:px-2 px-0 '>


            <div className='flex justify-center lg:flex-row flex-col mb-20 lg:px-0 md:px-8 px-2 lg:gap-x-3 lg:gap-y-0 gap-x-4 gap-y-20'>



                <div className=' print:hidden lg:block hidden lg:w-3/12 w-full mx-auto lg:px-4 px-1  md:left-0 fixed top-[160px]'>
                    <div className=''>
                        <div className={`bg-base-100 border-r-4 border-gray-600   rounded-lg }`}>
                            <div className="avatar flex justify-center items-center">
                                <div className="mt-2  w-[105px] rounded-full">
                                    <img className='mx-auto' src={fahim} alt='fahim' />
                                </div>
                            </div>
                            <p className='-mt-1 text-white text-2xl font-bold text-center px-6 py-3'>FAHIM FAYSAL</p>
                            <p className='-mt-1 text-[16px] text-justify px-4'>I am a full-stack developer from Bangladesh and am available to work in office or remotely.</p>
                            <p className='mt-3 text-[16px] text-amber-500 text-justify px-4'>Expert In: <span className='text-white'>ReactJS, NodeJS, MongoDB, Redux, Firebase</span></p>
                            <div className='flex justify-center items-center gap-x-4 mt-4'>
                                <div className=''>
                                    <a href='https://github.com/Fahimsakib1?tab=repositories' target='blank' className='tooltip' data-tip='GitHub'>
                                        <BsGithub className='text-white text-2xl my-2 hover:bg-black hover:text-white rounded-lg transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsGithub>
                                    </a>
                                </div>
                                <div className=''>
                                    <a href='https://www.linkedin.com/in/fahim-faysal/' target='blank' className='tooltip' data-tip='LinkedIn'>
                                        <BsLinkedin className='text-white text-2xl my-2 hover:text-blue-700 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsLinkedin>
                                    </a>
                                </div>
                                <div className=' '>
                                    <a href='https://www.instagram.com/i_fahiim/' target='blank' className='tooltip' data-tip='Instagram'>
                                        <BsInstagram className='text-white text-2xl my-2 hover:text-rose-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsInstagram>
                                    </a>
                                </div>
                                <div className=''>
                                    <a href='https://www.facebook.com/fahim.sakib.5' target='blank' className='tooltip' data-tip='Facebook'>
                                        <BsFacebook className='text-white text-2xl my-2 hover:text-blue-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsFacebook>
                                    </a>
                                </div>
                            </div>
                            <Link to='/contact'>
                                <div className='w-full mt-3 mx-auto text-center cursor-pointer'>
                                    <button className=' text-lg w-full px-16 py-2 bg-rose-700 hover:bg-rose-800 rounded-sm text-white'>Hire Me</button>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>













                <div className='lg:ml-[355px] lg:w-6/12 w-full mx-auto bg-white screen:shadow-2xl print:shadow-none md:px-6 px-2 py-8 ml:0'>


                    <div>

                        <div ref={ref} className='bg-white text-black mt-6'>

                            {
                                language === 'english' ?
                                    <>
                                        <h2 className='font-sans md:text-4xl text-3xl text-justify font-bold text-black mb-3'>Everything You Need to Know about Student Visa</h2>
                                        <p className='mt-8 text-justify px-2 text-gray-900 font-serif  md:text-[19px] text-[17px]'>If you are on a journey abroad for the pursuit of further education, you will be facing several stops before you reach the final destination. Standardised entrance tests, language proficiency tests, educational and financial documents and the penultimate stop on this journey is your student visa process.</p>
                                    </>
                                    :
                                    <>
                                        <h2 className='font-sans lg:text-[32px] md:text-[32px] text-[25px] text-justify font-bold text-black mb-3 leading-snug'>ছাত্র ভিসা সম্পর্কে আপনার যা জানা দরকার</h2>
                                        <p className='mt-8 text-justify px-2 text-gray-900  font-serif  md:text-[19px] text-[17px]'>আপনি যদি আরও শিক্ষা অর্জনের জন্য বিদেশ ভ্রমণে থাকেন তবে চূড়ান্ত গন্তব্যে পৌঁছানোর আগে আপনাকে বেশ কয়েকটি স্টপের সম্মুখীন হতে হবে। প্রমিত প্রবেশদ্বার পরীক্ষা, ভাষার দক্ষতা পরীক্ষা, শিক্ষাগত এবং আর্থিক নথি এবং এই যাত্রার চূড়ান্ত স্টপ হল আপনার ছাত্র ভিসা প্রক্রিয়া.</p>
                                    </>
                            }


                            <div>
                                <img className='md:h-80 h-64 w-full my-8' src={visa} alt="BlogImage" />
                            </div>


                            {
                                language === 'english' ?
                                    <>
                                        <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                            If you are someone who is unaware of the nitigities of applying for a student visa, you've landed at the right place! This blog will make you acquainted with a student visa guide with the minutest details of student visa including information on student visa USA requirements, age limit, cost, and how to get study visa! A visa is essentially a document which allows a person to stay in another country for a specified amount of time. A student visa, thus, is a document permitting a student to stay in another country for educational purposes. At times, the visa also permits the student to stay for some months or years after the education, depending upon various factors. Primarily, you will need a valid passport. Now, the requirement of its validity would differ from country to country. Some countries require a passport which must be valid even till the end of your course while some do not have that requirement. Furthermore, if you are a travel enthusiast, ensure that your passport has at least two blank pages left for the visa.
                                        </p>
                                        <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                            The rules are as candid as they are important. Indeed, you want to fit in at the university as well as in the country you are going to, right? Thus, you will essentially need to prove that you are proficient in their native language. If you are planning to head to an English-speaking country, then the most commonly accepted language proficiency tests are TOEFL, IELTS and/or PTE. If, however, your pursuit leads you to a country with a different native language, you will need to certify yourself in it. For instance, if you wish to go to Germany for your education, you must be certified with their CEFR Certified Levels. Before you register for a language proficiency test, make sure you check their validity in the country you are going to. A plethora of European universities do not accept TOEFL scores for language proficiency tests. Last, but definitely not the least. Most countries ask for proof that you are financially capable to study in the country as well as manage your living expenses. Some countries provide a specific number for the living expenses while some provide ambiguous guidelines. Alright, then. A question that has definitely popped in your mind: When to apply for a study abroad visa? Should you apply right away after receiving the admit? Maybe. Maybe not.
                                        </p>
                                        <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                            There is a limit on how early you can apply for an international student visa. For instance, if you are applying for an F-1 student visa to study in the US, you can apply no earlier than 120 days from the start of your classes. You can get the information from the embassy websites of the country you are targeting. Moreover, you will also find the application forms, required documentation and regulations concerning the student visa process. The visa interview questions and their corresponding answers are critically important and they decide the fate of your visa results. The questions are fairly straightforward and are intended to test your capability of living and studying abroad.
                                        </p>
                                        <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                            The visa questions you face will primarily interrogate your finances, the reason for choosing a particular course, your educational and professional background, your plans after the degree in the intended country, possibly your family background and your future goals. The result of your visa interview can either be Accepted/Approved. The Visa Officer will keep your passport with him/her and you can collect the stamped passport next day from the OFC Office or they can give you a visa rejection by issuing the Form 214b which is a general letter describing that you are a potential immigrant. In such an unfortunate event, don’t lose hope and don’t argue with the office. Accept the decision gracefully and move out of the consulate. Your actions post this might influence their decision during the next attempt of the interview.
                                        </p>

                                    </>
                                    :
                                    <>
                                        <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                            আপনি যদি এমন কেউ হন যিনি স্টুডেন্ট ভিসার জন্য আবেদন করার জটিলতা সম্পর্কে জানেন না, আপনি সঠিক জায়গায় পৌঁছেছেন! এই ব্লগটি আপনাকে স্টুডেন্ট ভিসা ইউএসএ প্রয়োজনীয়তা, বয়স সীমা, খরচ এবং কিভাবে স্টাডি ভিসা পেতে হয় সে সম্পর্কে তথ্য সহ স্টুডেন্ট ভিসার সবথেকে ছোট বিবরণ সহ স্টুডেন্ট ভিসা গাইডের সাথে পরিচিত করবে! একটি ভিসা মূলত একটি নথি যা একজন ব্যক্তিকে একটি নির্দিষ্ট সময়ের জন্য অন্য দেশে থাকার অনুমতি দেয়। একটি ছাত্র ভিসা, এইভাবে, একটি নথি যা একজন শিক্ষার্থীকে শিক্ষাগত উদ্দেশ্যে অন্য দেশে থাকার অনুমতি দেয়। অনেক সময়, ভিসা বিভিন্ন কারণের উপর নির্ভর করে শিক্ষার্থীকে শিক্ষার পর কয়েক মাস বা বছর থাকার অনুমতি দেয়। প্রাথমিকভাবে, আপনার একটি বৈধ পাসপোর্ট প্রয়োজন হবে। এখন, এর বৈধতার প্রয়োজনীয়তা দেশ ভেদে ভিন্ন হবে। কিছু দেশে একটি পাসপোর্টের প্রয়োজন হয় যা আপনার কোর্স শেষ হওয়া পর্যন্ত বৈধ হতে হবে যখন কিছুতে সেই প্রয়োজন নেই। উপরন্তু, আপনি যদি একজন ভ্রমণ উত্সাহী হন তবে নিশ্চিত করুন যে আপনার পাসপোর্টে ভিসার জন্য কমপক্ষে দুটি ফাঁকা পৃষ্ঠা রয়েছে।
                                        </p>
                                        <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                            নিয়মগুলি যেমন অকপট তেমনি গুরুত্বপূর্ণ। প্রকৃতপক্ষে, আপনি বিশ্ববিদ্যালয়ে পাশাপাশি যে দেশে যাচ্ছেন সেখানে ফিট করতে চান, তাই না? সুতরাং, আপনাকে অবশ্যই প্রমাণ করতে হবে যে আপনি তাদের স্থানীয় ভাষায় দক্ষ। আপনি যদি কোনো ইংরেজি-ভাষী দেশে যাওয়ার পরিকল্পনা করছেন, তাহলে সবচেয়ে বেশি স্বীকৃত ভাষার দক্ষতা পরীক্ষা হল TOEFL, IELTS এবং/অথবা PTE। যাইহোক, যদি আপনার সাধনা আপনাকে একটি ভিন্ন মাতৃভাষা সহ একটি দেশে নিয়ে যায়, তাহলে আপনাকে সেখানে নিজেকে প্রত্যয়িত করতে হবে। উদাহরণস্বরূপ, আপনি যদি আপনার শিক্ষার জন্য জার্মানিতে যেতে চান, তাহলে আপনাকে অবশ্যই তাদের CEFR সার্টিফাইড স্তরের সাথে প্রত্যয়িত হতে হবে। আপনি একটি ভাষার দক্ষতা পরীক্ষার জন্য নিবন্ধন করার আগে, আপনি যে দেশে যাচ্ছেন সেখানে তাদের বৈধতা যাচাই করে নিন। ইউরোপীয় বিশ্ববিদ্যালয়গুলির আধিক্য ভাষা দক্ষতা পরীক্ষার জন্য TOEFL স্কোর গ্রহণ করে না। শেষ, কিন্তু স্পষ্টভাবে অন্তত না. বেশিরভাগ দেশ প্রমাণ চায় যে আপনি দেশে পড়াশোনা করার পাশাপাশি আপনার জীবনযাত্রার ব্যয় পরিচালনা করতে আর্থিকভাবে সক্ষম। কিছু দেশ জীবনযাত্রার ব্যয়ের জন্য একটি নির্দিষ্ট সংখ্যা প্রদান করে যখন কিছু অস্পষ্ট নির্দেশিকা প্রদান করে। তাহলে ঠিকআছে. একটি প্রশ্ন যা আপনার মনে অবশ্যই উঁকি দিয়েছে: বিদেশে স্টাডি ভিসার জন্য কখন আবেদন করতে হবে? ভর্তি হওয়ার সাথে সাথে আপনার কি আবেদন করা উচিত? হতে পারে. হয়তো না.
                                        </p>
                                        <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                            আপনি কত তাড়াতাড়ি আন্তর্জাতিক ছাত্র ভিসার জন্য আবেদন করতে পারবেন তার একটি সীমা রয়েছে। উদাহরণস্বরূপ, আপনি যদি মার্কিন যুক্তরাষ্ট্রে পড়ার জন্য একটি F-1 স্টুডেন্ট ভিসার জন্য আবেদন করেন, আপনি আপনার ক্লাস শুরু হওয়ার 120 দিনের আগে আবেদন করতে পারবেন না। আপনি যে দেশের টার্গেট করছেন সে দেশের দূতাবাসের ওয়েবসাইট থেকে তথ্য পেতে পারেন। তাছাড়া, আপনি আবেদনপত্র, প্রয়োজনীয় ডকুমেন্টেশন এবং স্টুডেন্ট ভিসা প্রক্রিয়া সম্পর্কিত নিয়মাবলীও পাবেন। ভিসা ইন্টারভিউ প্রশ্ন এবং তাদের সংশ্লিষ্ট উত্তর সমালোচনামূলকভাবে গুরুত্বপূর্ণ এবং তারা আপনার ভিসার ফলাফলের ভাগ্য নির্ধারণ করে। প্রশ্নগুলি মোটামুটি সহজবোধ্য এবং বিদেশে বসবাস এবং অধ্যয়ন করার আপনার ক্ষমতা পরীক্ষা করার উদ্দেশ্যে।
                                        </p>
                                        <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                            আপনি যে ভিসা প্রশ্নগুলির মুখোমুখি হন সেগুলি প্রাথমিকভাবে আপনার অর্থ, একটি নির্দিষ্ট কোর্স বেছে নেওয়ার কারণ, আপনার শিক্ষাগত এবং পেশাগত পটভূমি, ইচ্ছাকৃত দেশে ডিগ্রির পরে আপনার পরিকল্পনা, সম্ভবত আপনার পারিবারিক পটভূমি এবং আপনার ভবিষ্যত লক্ষ্য নিয়ে জিজ্ঞাসাবাদ করবে। আপনার ভিসা ইন্টারভিউয়ের ফলাফল গৃহীত/অনুমোদিত হতে পারে। ভিসা অফিসার আপনার পাসপোর্ট তার কাছে রাখবেন এবং আপনি OFC অফিস থেকে পরের দিন স্ট্যাম্পযুক্ত পাসপোর্ট সংগ্রহ করতে পারেন অথবা তারা আপনাকে একটি সম্ভাব্য অভিবাসী বর্ণনা করে একটি সাধারণ চিঠি যা ফর্ম 214b ইস্যু করে ভিসা প্রত্যাখ্যান করতে পারে। এমন একটি দুর্ভাগ্যজনক ঘটনায়, আশা হারাবেন না এবং অফিসের সাথে তর্ক করবেন না। সদয়ভাবে সিদ্ধান্ত গ্রহণ করুন এবং কনস্যুলেট থেকে বেরিয়ে যান। এটি পোস্ট করা আপনার ক্রিয়াগুলি সাক্ষাত্কারের পরবর্তী প্রচেষ্টার সময় তাদের সিদ্ধান্তকে প্রভাবিত করতে পারে।
                                        </p>

                                    </>
                            }




                        </div>


                        <ReactPrint trigger={() => <button className='print:hidden ml-1 hover:scale-105 mt-28 mb-16 px-6 py-2 bg-green-600 text-white'>
                            <div className='text-[16px] text-white flex justify-start items-center gap-x-1'>
                                <BsFileEarmarkPdf size={25} className='text-white'></BsFileEarmarkPdf>
                                {
                                    language === 'english' ?
                                        <p>Download PDF</p>
                                        :
                                        <p>ডাউনলোড পিডিএফ</p>
                                }
                            </div>
                        </button>} content={() => ref.current}>
                        </ReactPrint>



                        {
                            language === 'english' ?
                                <h1 className='print:hidden mt-20 lg:mb-4 mb-3 md:text-3xl text-2xl text-start text-black font-bold'>Share This Post</h1>
                                :
                                <h1 className='print:hidden mt-20 lg:mb-4 mb-3 md:text-3xl text-2xl text-start text-black font-bold'>পোস্টটি শেয়ার করুন</h1>
                        }
                        <div className='print:hidden flex justify-start items-center'>
                            <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on Facebook'>
                                <FacebookShareButton
                                    url={shareUrl}
                                    quote={'Share Blog on Facebook'}
                                    hashtag={'#blog'}
                                    style={{ marginRight: '7px' }}
                                >
                                    <FacebookIcon size={38} round={true} />
                                </FacebookShareButton>
                            </div>
                            <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on Twitter'>
                                <TwitterShareButton
                                    url={shareUrl}
                                    quote={'Share Blog on Twitter'}
                                    hashtag={'#blog'}
                                    style={{ marginRight: '7px' }}
                                >
                                    <TwitterIcon size={38} round={true} />
                                </TwitterShareButton>
                            </div>
                            <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on LinkedIn'>
                                <LinkedinShareButton
                                    url={shareUrl}
                                    quote={'Share Blog on LinkedIn'}
                                    hashtag={'#blog'}
                                    style={{ marginRight: '7px' }}
                                >
                                    <LinkedinIcon size={38} round={true} />
                                </LinkedinShareButton>
                            </div>
                            <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on WhatsApp'>
                                <WhatsappShareButton
                                    url={shareUrl}
                                    quote={'Share Blog on WhatsApp'}
                                    hashtag={'#blog'}
                                    style={{ marginRight: '7px' }}
                                >
                                    <WhatsappIcon size={38} round={true} />
                                </WhatsappShareButton>
                            </div>
                        </div>


                    </div>



                </div>







                <div className='print:hidden lg:w-3/12 w-full mx-auto lg:px-4 px-1 '>
                    <div className='lg:right-auto lg:fixed lg:top-[160px] lg:mr-10 relative'>
                        <div className={`bg-gray-700 rounded-sm px-3 pt-2 pb-3`}>
                            <p className='text-white text-center text-lg -mt-1 px-6 py-1'>Read More Blogs... </p>

                            <div>
                                <Link to='/blog1'>
                                    <div className='hover:border-blue-500 cursor-pointer gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={npm} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='md:text-lg lg:text-[16px] text-md text-yellow-400 group-hover:text-white '>7 Most Popular Animation Libraries For React</p>
                                    </div>
                                </Link>

                                <Link to='/blog2'>
                                    <div className='hover:border-blue-500 cursor-pointer gap-x-3  mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={npm1} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start md:text-lg lg:text-[16px] text-md text-yellow-400 group-hover:text-white '>Worst npm Packages you should not use</p>
                                    </div>
                                </Link>


                                <Link to='/blog7'>
                                    <div className='hover:border-blue-500 cursor-pointer gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={resume} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start md:text-lg lg:text-[16px] text-md text-yellow-400 group-hover:text-white '>How To Improve Your Resume In 9 Steps</p>
                                    </div>
                                </Link>

                                <Link to='/blog3'>
                                    <div className='hover:border-blue-500 cursor-pointer gap-x-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={studyAbroad} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start text-yellow-400 group-hover:text-white  md:text-lg lg:text-[16px]  text-md '>Why Study Abroad? Stories From International Students</p>
                                    </div>
                                </Link>







                                {/* <div className=' -mt-12 lg:w-[300px] md:w-[680px] sm:w-[350px] w-[350px]  '>
                                    <Swiper
                                        pagination={{
                                            clickable: true
                                        }}
                                        modules={[Pagination, Autoplay, Navigation]}
                                        autoplay={{ delay: 2000 }}
                                        className="mySwiper"
                                    >

                                        <SwiperSlide className=''>
                                            <div>
                                                <Link to='/blog5'>
                                                    <div className=' hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3 mb-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={program} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md '>4 Reasons Why Year Gap In Study Isn't End of life</p>
                                                    </div>
                                                </Link>
                                                <Link to='/blog2'>
                                                    <div className='hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3  mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={npm1} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start md:text-lg lg:text-[16px] text-md text-yellow-400 underline'>Worst npm Packages you should not use</p>
                                                    </div>
                                                </Link>

                                            </div>
                                        </SwiperSlide>


                                        <SwiperSlide className=''>
                                            <div>

                                                <Link to='/blog7'>
                                                    <div className='hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3 mb-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={resume} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start md:text-lg lg:text-[16px] text-md text-yellow-400 underline'>How To Improve Your Resume In 9 Steps</p>
                                                    </div>
                                                </Link>
                                                <Link to='/blog3'>
                                                    <div className='hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={studyAbroad} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md '>Why Study Abroad? Stories From International Students</p>
                                                    </div>
                                                </Link>
                                            </div>
                                        </SwiperSlide>

                                    </Swiper>
                                </div> */}



                            </div>
                        </div>
                    </div>
                </div>




            </div>



        </div>
    );
};

export default Blog4Details;